import cn from "classnames";
import iPinkDuck from "../../../assets/icons/hero/pink_duck.webp";
import iWhitePolygon from "../../../assets/icons/white-polygon.svg";
import "./menu-item.sass";
import { TColor } from "../../../types/types";

type Props = {
  title: string;
  icon?: string;
  setSelected: () => void;
  isSelected: boolean;
  color?: TColor;
  className?: string;
};

const MenuItem = ({
  setSelected,
  icon,
  title,
  isSelected,
  color,
  className,
}: Props) => {
  return (
    <div
      className={cn(
        `menu-item menu-item__${!isSelected ? color?.id ?? "" : ""} ${
          className ? className : ""
        }`,
        {
          _active: isSelected,
        },
      )}
      onClick={setSelected}
    >
      {!isSelected && icon && (
        <img src={icon} className="menu-item__icon" alt="" />
      )}

      {!isSelected && color && (
        <div
          className="menu-item__icon menu-item__icon_polygon"
          style={{
            backgroundColor: color.hex,
            WebkitMaskImage: `url(${iWhitePolygon})`,
            maskImage: `url(${iWhitePolygon})`,
          }}
        />
      )}

      {isSelected && (icon || color) && (
        <div className="menu-item__icon-selected" />
      )}

      {!icon && !color && (
        <img src={iPinkDuck} className="menu-item__duck" alt="" />
      )}

      <div className="menu-item__title">{title}</div>
    </div>
  );
};

export default MenuItem;
